import { AlarmMultipleIcon } from './AlarmMultipleIcon';

/**
 * author: Austin Andrews
 * id 67D410AB-495A-41BD-B9D8-20A7DFBBF623
 * name alarm-multiple
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alarm-multiple.svg
 * tags
 * - Date / Time 
 */
export const AlarmClocksIcon = AlarmMultipleIcon;
export default AlarmClocksIcon